










































































import Vue from "vue";
import PageHeading from "@/components/PageHeading.vue";
import SupportedBanks from "@/components/application/StepDocuments/SupportedBanks.vue";
import { apiAxios } from "@/store/apiAxios";
import { BIconCheck2Circle } from "bootstrap-vue";

export default Vue.extend({
  name: "BankLink",
  components: {
    PageHeading,
    SupportedBanks,
    BIconCheck2Circle,
  },
  data() {
    return {
      market: "",
      loading: false,
      isError: false,
      userId: null as number | null,
      loanId: null as number | null,
      token: "",
      bankSelected: "",
      intervalId: null as null | number,
      isBankConnected: false,
      summary: {
        loaded: false,
        isLinked: 0,
        isRejected: 0,
        isInProgress: 0,
        isError: 0,
      },
    };
  },
  created() {
    this.userId =
      this.$route.query.userId && !Array.isArray(this.$route.query.userId)
        ? parseInt(this.$route.query.userId, 10)
        : null;
    this.loanId =
      this.$route.query.loanId && !Array.isArray(this.$route.query.loanId)
        ? parseInt(this.$route.query.loanId, 10)
        : null;
    this.token =
      this.$route.query.token && !Array.isArray(this.$route.query.token)
        ? this.$route.query.token
        : "";
    this.market = this.$route.params.market || "";

    if (this.userId === null || this.loanId === null || !this.token) {
      this.isError = true;
    }

    this.getLoanStatus();
  },
  methods: {
    async getLoanStatus() {
      try {
        const result = await apiAxios.post(
          `api/guest/loan-status/`,
          {
            environment: this.market,
            user_id: this.userId,
            loan_id: this.loanId,
            token: this.token,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        this.summary = {
          loaded: true,
          ...result.data,
        };
      } catch (e) {
        this.isError = true;
      }
    },
    async newConsent() {
      this.isBankConnected = false;
      const result = await apiAxios.post(
        `api/guest/bank-link/`,
        {
          environment: this.market,
          user_id: this.userId,
          loan_id: this.loanId,
          bank_id: this.bankSelected,
          token: this.token,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const a = document.createElement("a");
      a.href = result.data.consent_link;
      a.target = "_blank";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      this.pollForChanges(result.data.id);
      this.getLoanStatus();
      this.loading = false;
    },

    pollForChanges(bankstatementId: string) {
      // Make sure we are not polling for two different bank statements
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }

      this.intervalId = window.setInterval(async () => {
        const response = await apiAxios.post(
          `api/guest/status/`,
          {
            environment: this.market,
            loan_id: this.loanId,
            token: this.token,
            bankstatement_id: bankstatementId,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        if (response.data.is_linked) {
          this.isBankConnected = true;
          this.getLoanStatus();
        }

        if (response.data.is_linked || response.data.is_error) {
          if (this.intervalId) {
            clearInterval(this.intervalId);
            this.intervalId = null;
          }
        }
      }, 5000);
    },
  },
});
